

.card {

  position: relative;

  .locked
  {
    position: absolute;
    right: 2em;
    top: 2em;
  }

  &.basic {
    .avatar {
      svg {
        fill: var(--beigedarker);
      }
    }
  }

  .avatar {
    display: flex;
    border-radius: 50%;
    object-fit: cover;
    width: 130px;
    height: 130px;
    border: 4px solid var(--beige);
    margin: auto auto 20px;
    overflow: hidden;
    background-color: var(--beige);
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }


    svg {
      font-size: 2.4em;
      fill: var(--red);
    }
  }

  .content {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    flex-grow: 1;

    .title {
      font-family: var(--font-bold);
      font-size: 16px;
      text-align: center;
      color: black;
    }

    .meta {
      color: var(--beigedarker);
      font-size: 0.9em;
      display: inline-block;
      text-align: center;
      gap: 10px;


      svg {
        height: 15px;
        display: inline-block;
        vertical-align: baseline;
        margin: 0 .3em;
      }
    }
  }

  .stats {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: auto 0 0 0;

    li {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: var(--beigedarker);
      line-height: 14px;
      background: var(--beigelight);
      border-radius: 15px;
      padding: 10px;
      margin: 0 5px 5px 5px;

      svg {
        height: 10px;
        margin-right: 5px;
      }
    }
  }
}



.isObituary {

  overflow: hidden;
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;

  > div {
    position: absolute;
    background: var(--beigelight);
    border-top: 2px solid var(--beigedark);
    border-bottom: 2px solid var(--beigedark);
    color: var(--beigedarker);
    text-align: center;
    rotate: 45deg;
    width: 200px;
    right: -50px;
    top: 40px;
  }
}


.publishState
{
  position: absolute;
  top: 1em;
  left: 1em;
}
